import React, { useState, useEffect } from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { Calendar } from '../../coach_services/OutplacementBenefits/Calendar'
import { getApi } from '~/util/api'
import { Card, Typography } from '~/components/_atoms'
import { Stack } from '~/components/_layouts'
import Spinner from '~/components/shared/Spinner'
import EmailSignUpModal from './EmailSignUpModal'
import { useBenefits } from '~/components/coach_services/BenefitsProvider'
import { useFormatTime } from '~/hooks/useFormatTime'

export function UpcomingWebinarsCard({ className }) {
  const { t } = useTranslation('upcoming_webinars_card')
  const [isLoading, setIsLoading] = useState(false)
  const [calendarEvents, setCalendarEvents] = useState({ events: [] })
  const { current_user } = useBenefits()
  const formatTime = useFormatTime(current_user?.locale)
  const hasLiveEventsNotifications =
    !!current_user?.live_events_notifications_on

  useEffect(() => {
    setIsLoading(true)
    getApi()
      .get('coach_services/upcoming_webinars')
      .then((response) => {
        if (response.status == 200) {
          setCalendarEvents(response.data)
          return
        } else {
          throw new Error('json request failed')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
      .catch((error) => {
        console.log('json request failed', error)
      })
  }, [setCalendarEvents])

  return (
    <Card className={className} color="secondary">
      <Stack spacing={3}>
        <Typography variant="title4" color="secondary" component="h2">
          {t('title')}
        </Typography>
        <Typography>{t('description')}</Typography>
        {isLoading ? (
          <div className="flex items-center justify-center ">
            <Spinner show className="h-9 w-9" />
          </div>
        ) : (
          <>
            <div className="relative [&&]:hidden @3xl:[&&]:block">
              <Calendar
                calendar_events={calendarEvents.events}
                homePageDisplay={true}
                coachDashboardDisplay={false}
                locale={current_user?.locale}
              />
            </div>
            <div className="@3xl:hidden">
              <Stack spacing={6}>
                {calendarEvents.events.map((event) => (
                  <a
                    key={`event_${event.id}`}
                    href={`/coach_services/upcoming_events?event_id=${event.id}&mode=list`}
                    className="block w-full rounded-md border border-intoo-green-medium-700 px-4 py-2"
                  >
                    <Typography className="font-medium" color="secondary">
                      {event.webinar_type}
                    </Typography>
                    <Typography variant="small">
                      {formatTime(event.start_at, 'long')}
                    </Typography>
                  </a>
                ))}
              </Stack>
            </div>
            <div className="flex justify-start">
              <EmailSignUpModal
                hasLiveEventsNotifications={hasLiveEventsNotifications}
              />
            </div>
          </>
        )}
      </Stack>
    </Card>
  )
}
